import React from 'react';
import { FadeIn } from './FadeIn';
import { PricingSelector } from './PricingSelector';
export function PricingCards() {
  return <section className="py-6 md:py-10 px-4 max-w-5xl mx-auto" id="pricing" data-id="element-258">
      <FadeIn data-id="element-259">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-5 md:mb-8 tracking-tight text-[#0f172a]" data-id="element-260">
          ELEGÍ TU SISTEMA
        </h2>
      </FadeIn>

      <FadeIn delay={0.1} data-id="element-261">
        <PricingSelector variant="light" data-id="element-262" />
      </FadeIn>
    </section>;
}